<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>接口授权管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.account" placeholder="输入账号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
              element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="60"></el-table-column>
      <el-table-column sortable prop="id" label="ID" width="60"></el-table-column>
      <el-table-column prop="account" label="账号"></el-table-column>
      <el-table-column prop="phone" label="电话" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="phone1" label="微信用户电话">
      </el-table-column>
      <el-table-column prop="status" label="是否启用">
        <template slot-scope="scope">
          <div>{{scope.row.status == 1 ? '是': '否'}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog('editForm')">
      <el-form label-width="120px" :model="editForm" ref="editForm">
        <el-row>
          <el-col :span="24">
            <el-form-item label="账号">
              <el-input size="small" v-model="editForm.account" auto-complete="off"
                        placeholder="请输入账号"></el-input>
            </el-form-item>
            <el-form-item label="密码">
              <el-input size="small" v-model="editForm.password" auto-complete="off"
                        placeholder="请输入密码"></el-input>
            </el-form-item>
            <el-form-item label="电话">
              <el-input size="small" v-model="editForm.phone" auto-complete="off"
                        placeholder="请输入电话"></el-input>
            </el-form-item>
            <el-form-item label="是否启用">
              <el-switch v-model="editForm.status" active-color="#13ce66" inactive-color="#ff4949">
              </el-switch>
            </el-form-item>
            <el-form-item label="微信管理员" prop="uid">
              <el-select v-model="editForm.user_id" placeholder="请选择微信管理员">
                <el-option v-for="item in manager" :label="item.phone"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <div class="dialog-footer">
                <el-button size="small" @click="closeDialog">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title"
                           @click="submitForm('editForm')">保存
                </el-button>
              </div>
            </el-form-item>

          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import Pagination from '../../components/Pagination'
  import {searchApiAuth, saveApiAuth, deleteApiAuth, wechatManagers, wechatManager} from "../../api/userMG";

  export default {
    data() {
      return {
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        operatorVisible: false, //控制操作员页面显示与隐藏
        title: '添加/修改授权用户',
        editForm: {
          id: null,
          status: 0,
          account: '',
          password: '',
          phone: '',
          user_id: ''
        },
        formInline: {
          page: 1,
          limit: 10,
          account: '',
          phone: '',
        },
        manager: [],
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
      this.getWechatManagers()
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      getWechatManagers() {
        wechatManagers().then(res => {
          if (res.code == 200) {
            this.manager = res.data
          }
        })
      },
      getdata(parameter) {
        this.loading = true
        // 模拟数据开始
        searchApiAuth(parameter).then(res => {
          this.listData = res.items
          this.loading = false
          this.pageparm.currentPage = this.formInline.page
          this.pageparm.pageSize = this.formInline.limit
          this.pageparm.total = res.pageInfo.total
        })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.getdata(this.formInline)
      },
      //显示编辑界面
      handleEdit: function (row) {
        this.editFormVisible = true
        if (row != undefined) {
          row.status = row.status == 1 ? true : false
          row.password = ''
          this.editForm = row
        }
      },
      // 编辑、增加页面保存方法
      submitForm(editData) {
        this.$refs[editData].validate(valid => {
          if (valid) {
            let row = this.editForm
            let params = {
              id: row.id,
              account: row.account,
              password: row.password,
              phone: row.phone,
              user_id: row.user_id,
              status: row.status == true ? 1 : 0
            }
            saveApiAuth(params)
              .then(res => {
                this.editFormVisible = false
                this.loading = false
                if (res.code == 200) {
                  this.$message({
                    type: 'success',
                    message: '保存成功！'
                  })
                  this.getdata(this.formInline)
                } else {
                  this.$message({
                    type: 'info',
                    message: '保存失败！'
                  })
                }
              })
              .catch(err => {
                this.editFormVisible = false
                this.loading = false
                this.$message.error('授权账号保存失败，请稍后再试！')
              })
          } else {
            return false
          }
        })
      },
      // 删除授权账号
      deleteUser(row) {
        this.$confirm('确定要删除吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteApiAuth({id: [row.id]})
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: '授权账号已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: '授权账号删除失败!'
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('授权账号删除失败，请稍后再试！')
            })
        })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      },
      // 关闭编辑、增加弹出框
      closeDialog(formName) {
        this.editFormVisible = false
        this.$refs[formName].resetFields()
      }
    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }
</style>







// WEBPACK FOOTER //
// src/views/apiAuth/index.vue